import { toI18n } from 'util/i18n';

const reasons = [
  'vacation',
  'paid_vacation',
  'holiday',
  'jury_duty',
  'sick_leave',
  'personal_medical_emergency',
  'family_medical_emergency',
  'other',
];

export const REASONS = reasons.map(reason => ({
  label: toI18n(`enums.category.${reason}`),
  value: reason,
}));

const categories = [
  'unpaid_time_off',
  'paid_sick_leave_no_policy',
  'paid_sick_leave',
  'pto',
  'pto_no_policy',
];

export const CATEGORIES = categories.map(category => ({
  label: toI18n(`schedule_builder.react_page.time_off.categories.${category}`),
  value: category,
}));

export const CATEGORIES_NO_REASON = [
  'pto',
  'pto_no_policy',
  'paid_sick_leave',
  'paid_sick_leave_no_policy',
];
